const { cxt } = require('./context');

const name = [
  'whitespace',
  cxt('min-length', { length: 2, isTrim: true}),
  cxt('pattern', { pattern: /^([a-zA-Z]+['\-|\s])*[a-zA-Z]+$/ })
];

const nameRequired = [
  'required',
  'whitespace',
  cxt('min-length', { length: 2, isTrim: true }),
  cxt('pattern', { pattern: /^([a-zA-Z]+['\-|\s])*[a-zA-Z]+$/ })
];

const fullName = [
  'whitespace',
  cxt('pattern', { pattern: /^[a-zA-Z][a-zA-Z '-]{0,} [a-zA-Z][a-zA-Z '-]{0,}$/ }),
];

const fullNameRequired = [
  'required',
  'whitespace',
  cxt('pattern', { pattern: /^[a-zA-Z][a-zA-Z '-]{1,} [a-zA-Z][a-zA-Z '-]{1,}$/ }),
];

const alphanumericName = [
  'whitespace',
  cxt('min-length', { length: 2, isTrim: true }),
  cxt('pattern', { pattern: /^([a-zA-Z0-9]+['\-|\s])*[a-zA-Z0-9]+$/ })
];

const alphanumericNameRequired = [
  'required',
  'whitespace',
  cxt('min-length', { length: 2, isTrim: true }),
  cxt('pattern', { pattern: /^([a-zA-Z0-9]+['\-|\s])*[a-zA-Z0-9]+$/ })
];

const alphanumericFullname = [
  'whitespace',
  cxt('min-length', { length: 2, isTrim: true }),
  cxt('pattern', { pattern: /^[a-zA-Z0-9][a-zA-Z0-9 '-]{0,} [a-zA-Z0-9 '-]{0,}$/ }),
];

const alphanumericFullnameRequired = [
  'required',
  'whitespace',
  cxt('min-length', { length: 2, isTrim: true }),
  cxt('pattern', { pattern: /^[a-zA-Z0-9][a-zA-Z0-9 '-]{0,} [a-zA-Z0-9 '-]{0,}$/ }),
];

module.exports = {
  name,
  nameRequired,
  fullName,
  fullNameRequired,
  alphanumericName,
  alphanumericNameRequired,
  alphanumericFullname,
  alphanumericFullnameRequired,
};
